import React from 'react';
import CommandesPeriode from './CommandesPeriode';

// Onglet « Commandes du jour » — délègue au composant générique
// (avant : quasi-duplication à 95% avec ListeCommande7jrs).
const ListeCommandeJour = () => (
  <CommandesPeriode endpoint="commandeJour" emptyText="Aucune commande aujourd'hui." />
);

export default ListeCommandeJour;
